import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import SupportTickets from "../pages/dashboardPage/supportTickets/SupportTickets";
import EmailDelivery from "../pages/dashboardPage/supportTickets/emailDelivery/EmailDelivery";

// Tab id (permissionCatalog "support-tickets") → its page.
const TAB_PAGES = {
  tickets: SupportTickets,
  "email-delivery": EmailDelivery,
};

const SupportTicketsNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("support-tickets", rolePermissions);
  const first = tabs[0];

  return (
    <Routes>
      {first && <Route index element={<Navigate to={first.path} replace />} />}
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {first && <Route path="*" element={<Navigate to={first.path} replace />} />}
    </Routes>
  );
};

export default SupportTicketsNavigator;
